module.exports = __webpack_public_path__ + "fa5b593569a36da395278814318b925b.pdf";